{
  "filterConfig": {
    "filterFields": [
      {
        "name": "DOCUMENT_NO_CONTAINS",
        "displayLabel": "Document  No",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "DOCUMENT_NO_EQUALS"
        }
      },
      {
        "name": "BL_NO_CONTAINS",
        "displayLabel": "BL No",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "BL_NO_CONTAINS"
        }
      },
      {
        "name": "BOE_NO_CONTAINS",
        "displayLabel": "BOE No",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "BOE_NO_CONTAINS"
        }
      },
      {
        "name": "ACCOUNT_HOLDER_EQUALS",
        "displayLabel": "Account holder",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "ACCOUNT_HOLDER_EQUALS"
        },
        "hasLookup": true,
        "searchConfig": {
          "apiUrl": "v1/customers/list",
          "selectFields": ["id", "name", "code"],
          "filterByKeys": ["NAME_CONTAINS"],
          "additionalFilters": [
            {
              "name": "IS_ACTIVE",
              "alias": "active",
              "operator": "EQ",
              "value": [true]
            }
          ],
          "limit": 10,
          "orderBy": { "name": "asc" },
          "bindLabel": "name",
          "bindValue": "id",
          "displayColumns": [{ "key": "name", "header": "Name" }]
        }
      },
      {
        "name": "CHA_EQUALS",
        "displayLabel": "CHA",
        "dataType": "STRING",
        "hasLookup": true,
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "CHA_EQUALS"
        },
        "searchConfig": {
          "apiUrl": "v1/customers/list",
          "filterByKeys": ["NAME_CONTAINS"],
          "additionalFilters": [
            {
              "name": "IS_ACTIVE",
              "alias": "active",
              "operator": "EQ",
              "value": ["true"]
            },
            {
              "name": "CUSTOMER_TYPE_CONTAINS",
              "alias": "customerType",
              "operator": "EQ",
              "value": ["CHA"]
            }
          ],
          "limit": 10,
          "orderBy": { "name": "asc" },
          "bindLabel": "name",
          "bindValue": "id",
          "displayColumns": [{ "key": "name", "header": "Name" }]
        }
      },
      {
        "name": "CONTAINER_NO_CONTAINS",
        "displayLabel": "Container No",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "CONTAINER_NO_CONTAINS"
        }
      },
      {
        "name": "VESSEL_EQUALS",
        "displayLabel": "Vessel",
        "dataType": "STRING",
        "hasLookup": true,
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "VESSEL_EQUALS"
        },
        "searchConfig": {
          "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
          "selectFields": ["id", "vesselName", "viaNo"],
          "filterByKeys": ["VESSEL_NAME_CONTAINS"],
          "limit": 10,
          "orderBy": { "vesselName": "asc" },
          "bindLabel": "vesselName",
          "bindValue": "id",
          "displayColumns": [{ "key": "vesselName", "header": "Vessel Name" }],
          "additionalFilters": {
            "name": "IS_ACTIVE",
            "alias": "IS_ACTIVE",
            "operator": "EQ",
            "value": ["true"]
          }
        }
      },
      {
        "name": "IMPORT_TYPE_EQUALS",
        "displayLabel": "Import Type",
        "dataType": "STRING",
        "supportedOperators": ["EQ"],
        "operatorToFilterMap": {
          "EQ": "IMPORT_TYPE_EQUALS"
        }
      }
    ],
    "useNewContract": true
  },
  "searchBarConfig": {
    "placeHolder": "Search item",
    "filters": [
      {
        "name": "DOCUMENT_NO_CONTAINS",
        "alias": "item_number"
      }
    ]
  },

  "defaultFilters": {
    "filterConditions": [
      {
        "name": "DOCUMENT_TYPE_EQUALS",
        "alias": "documentType",
        "value": ["BOE"]
      }
    ],
    "expression": "documentType"
  },

  "tableConfig": {
    "columns": [
      {
        "fieldName": "igmNo",
        "displayName": "IGM No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        }
      },
      {
        "fieldName": "itemNo",
        "displayName": "Item No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "40px"
        }
      },
      {
        "fieldName": "subItemNo",
        "displayName": "Sub Item No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "60px"
        }
      },
      {
        "fieldName": "boeNo",
        "displayName": "BOE No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        }
      },
      {
        "fieldName": "blNo",
        "displayName": "MBL No",
        "dataType": "STRING"
      },
      {
        "fieldName": "hblNo",
        "displayName": "HBL No",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "125px"
        }
      },
      {
        "fieldName": "vesselName",
        "displayName": "Vessel",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        },
        "styleConfig": {
          "styleProperties": {
            "width": "36px",
            "border-radius": "6px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "13px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          }
        }
      },
      {
        "fieldName": "accountHolderName",
        "displayName": "Account Holder",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "270px"
        }
      },
      {
        "fieldName": "commodityValue",
        "displayName": "Commodity",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "140px"
        },
        "styleConfig": {
          "type": "badge",
          "conditions": [
            {
              "expression": "eq(value, undefined)",
              "styleProperties": {
                "display": "none"
              }
            }
          ],
          "styleProperties": {
            "width": "100px",
            "display": "flex",
            "align-items": "center",
            "border-radius": "6px",
            "border": "1px solid #D0D5DD",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            "color": "var(--Gray-700, #344054)",
            "text-align": "center",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px"
          }
        }
      },

      {
        "fieldName": "consigneeName",
        "displayName": "Consignee",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "300px"
        }
      },
      {
        "fieldName": "importType",
        "displayName": "Import Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "width": "36px",
            "border-radius": "6px",
            "padding": "2px 8px",
            "align-items": "center",
            "display": "flex",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
          }
        }
      },
      {
        "fieldName": "hazardous",
        "displayName": "Hazardous",
        "dataType": "BOOLEAN",
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "align-items": "center",
            "border-radius": "16px",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'true')",
              "icon": "assets/icons/frame_icon.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "16px",
                "height": "16px",
                "background": "#D92D20"
              },
              "styleProperties": {
                "gap": "4px",
                "border": "1px solid var(--Error-200, #FECDCA)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Error-700, #B42318)"
              }
            },
            {
              "expression": "eq(value, 'false')",
              "styleProperties": {
                "padding": "2px 8px",
                "width": "40px",
                "border": "1px solid var(--Gray-200, #E4E7EC)",
                "background": "var(--Gray-50, #F9FAFB)",
                "color": "var(--Gray-700, #344054)"
              }
            }
          ]
        }
      },
      {
        "fieldName": "numberOfPackages",
        "displayName": "NOP",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "50px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
            "border-bottom": "1px solid var(--Gray-100, #F2F4F7)",
            "background": "var(--Gray-100, #F2F4F7)",
            "color": "var(--Gray-700, #344054)",
            "text-align": "center",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "600",
            "line-height": "18px"
          }
        }
      },
      {
        "fieldName": "modifiedBy",
        "dbName": "modified_by",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified Date",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  }
}
